export default "/img/member/icons/streamline-icon-ruler@30x30.svg"